export const tickerItems = [
  "今夜热播 · 连麦风波第 3 期切片已更新",
  "录屏流出 · 后台私聊截图合集补全到 12 张",
  "直播回放 · 周末红毯夜场全程已归档",
  "表情包上新 · 阴阳怪气系列 8 枚可下载",
  "视频片段 · 嘉宾金句 TOP10 单独切好",
  "截图合集 · 吃瓜时间线日历版已排版",
];

export const navChannels = [
  { id: "clips", label: "视频片段", icon: "ri-vidicon-line" },
  { id: "shots", label: "截图合集", icon: "ri-collage-line" },
  { id: "records", label: "录屏流出", icon: "ri-record-circle-line" },
  { id: "lives", label: "直播回放", icon: "ri-live-line" },
  { id: "memes", label: "表情包", icon: "ri-emotion-laugh-line" },
  { id: "trend", label: "传播节奏", icon: "ri-fire-line" },
];

export interface VideoItem {
  title: string;
  tag: string;
  length: string;
  heat: string;
  cover: string;
}

export const videoClips: VideoItem[] = [
  {
    title: "第 3 期完整切片 · 一句话带飞全场的名场面",
    tag: "金句切片",
    length: "02:48",
    heat: "9.4万热度",
    cover: "https://readdy.ai/api/search-image?query=editorial%20tabloid%20collage%20of%20a%20talk%20show%20stage%20silhouette%20speaking%20into%20a%20microphone%20under%20a%20warm%20amber%20spotlight%2C%20layered%20torn%20paper%20cutouts%2C%20coral%20and%20orange%20gradient%20light%2C%20soft%20bokeh%2C%20film%20grain%2C%20vignette%2C%20premium%20print%20magazine%20mood%2C%20no%20identifiable%20face&width=1200&height=750&seq=chigua-vf1&orientation=landscape",
  },
  {
    title: "连麦互怼名场面 · 全程高能情绪峰值回放",
    tag: "连麦实录",
    length: "06:12",
    heat: "12.8万热度",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20backlit%20shot%20of%20two%20blurred%20silhouettes%20facing%20across%20a%20neon%20lounge%20table%2C%20warm%20coral%20rim%20light%2C%20lively%20atmosphere%2C%20editorial%20pop%20culture%20poster%20energy%2C%20film%20grain%2C%20tear%20paper%20cutout%20texture%2C%20no%20identifiable%20faces&width=1200&height=750&seq=chigua-vf2&orientation=landscape",
  },
  {
    title: "场内观众手机视角 · 拍到争议瞬间的原片",
    tag: "现场直击",
    length: "01:24",
    heat: "7.6万热度",
    cover: "https://readdy.ai/api/search-image?query=moody%20editorial%20photo%20of%20a%20hand%20holding%20a%20smartphone%20with%20floating%20chat%20bubbles%2C%20warm%20amber%20screen%20glow%2C%20blurred%20crowd%20bokeh%20behind%2C%20coral%20and%20orange%20tones%2C%20film%20grain%2C%20magazine%20cover%20layout%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1200&height=750&seq=chigua-vf3&orientation=landscape",
  },
  {
    title: "导播台随手录 · 情绪转变最快的 90 秒",
    tag: "导播回放",
    length: "01:30",
    heat: "5.1万热度",
    cover: "https://readdy.ai/api/search-image?query=editorial%20shot%20of%20a%20broadcast%20control%20room%20with%20glowing%20monitors%20and%20a%20mixing%20desk%2C%20warm%20orange%20and%20amber%20screen%20glow%2C%20cinematic%20depth%2C%20film%20grain%2C%20layered%20cutout%20collage%20style%2C%20premium%20documentary%20look%2C%20no%20identifiable%20people&width=1200&height=750&seq=chigua-vf4&orientation=landscape",
  },
  {
    title: "复古电视机流出 · 老式画质氛围感片段",
    tag: "复古流出",
    length: "00:58",
    heat: "3.2万热度",
    cover: "https://readdy.ai/api/search-image?query=vintage%20analog%20crt%20television%20glowing%20warm%20static%20in%20a%20dark%20room%2C%20retro%20scanlines%2C%20amber%20and%20coral%20ambient%20light%2C%20editorial%20nostalgia%20collage%2C%20film%20grain%2C%20cinematic%20mood%2C%20no%20readable%20text&width=1200&height=750&seq=chigua-vf5&orientation=landscape",
  },
  {
    title: "复盘解说版 · 用字幕把来龙去脉捋清楚",
    tag: "复盘解说",
    length: "09:05",
    heat: "8.3万热度",
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20typing%20on%20a%20laptop%20with%20an%20editing%20timeline%20visible%2C%20warm%20desk%20lamp%20light%2C%20amber%20tones%2C%20film%20grain%2C%20editorial%20behind%20the%20scenes%20collage%2C%20layered%20paper%20texture%2C%20no%20identifiable%20person&width=1200&height=750&seq=chigua-vf6&orientation=landscape",
  },
  {
    title: "嘉宾下台瞬间 · 现场情绪反差切片",
    tag: "现场反差",
    length: "00:42",
    heat: "2.9万热度",
    cover: "https://readdy.ai/api/search-image?query=empty%20stage%20with%20a%20single%20stool%20and%20microphone%20under%20a%20focused%20spotlight%20cone%2C%20warm%20amber%20bokeh%2C%20dramatic%20silhouette%20mood%2C%20film%20grain%2C%20editorial%20cinema%20poster%2C%20coral%20and%20orange%20palette&width=1200&height=750&seq=chigua-vf7&orientation=landscape",
  },
  {
    title: "幕后花絮 · 彩排走位意外全记录",
    tag: "花絮彩蛋",
    length: "03:20",
    heat: "4.4万热度",
    cover: "https://readdy.ai/api/search-image?query=sunglasses%20and%20a%20folded%20magazine%20resting%20on%20a%20newspaper%20table%20with%20a%20cup%20of%20coffee%2C%20warm%20afternoon%20amber%20light%2C%20editorial%20print%20collage%2C%20film%20grain%2C%20layered%20cutout%20texture%2C%20cozy%20magazine%20mood&width=1200&height=750&seq=chigua-vf8&orientation=landscape",
  },
];

export interface ShotItem {
  title: string;
  count: string;
  cover: string;
}

export const screenshotShows: ShotItem[] = [
  {
    title: "后台私聊长截图 · 时间线完整版",
    count: "12 张",
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20smartphone%20screenshots%20showing%20messy%20chat%20app%20conversations%2C%20warm%20screen%20glow%2C%20angled%20paper%20pile%2C%20coral%20and%20amber%20lighting%2C%20editorial%20collage%2C%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20faces&width=1200&height=820&seq=chigua-sh1&orientation=landscape",
  },
  {
    title: "弹幕刷屏现场 · 实时留言合集",
    count: "18 张",
    cover: "https://readdy.ai/api/search-image?query=colage%20of%20notification%20cards%20and%20chat%20logs%20on%20dark%20phone%20ui%2C%20warm%20coral%20accent%20lights%2C%20glossy%20reflections%2C%20film%20grain%2C%20editorial%20archive%20style%2C%20no%20readable%20text%2C%20no%20identifiable%20people&width=1200&height=820&seq=chigua-sh2&orientation=landscape",
  },
  {
    title: "群聊名场面 · 转折点截图对照",
    count: "9 张",
    cover: "https://readdy.ai/api/search-image?query=angled%20phone%20screen%20showing%20a%20group%20chat%20interface%2C%20soft%20reflections%20and%20warm%20amber%20light%2C%20coral%20accents%2C%20cinematic%20depth%20of%20field%2C%20film%20grain%2C%20editorial%20collage%2C%20no%20readable%20text&width=1200&height=820&seq=chigua-sh3&orientation=landscape",
  },
  {
    title: "吃瓜时间线 · 事件推进日历排版",
    count: "24 张",
    cover: "https://readdy.ai/api/search-image?query=montage%20of%20cropped%20screenshot%20strips%20pinned%20on%20a%20warm%20cork%20moodboard%2C%20amber%20desk%20lamp%20light%2C%20paper%20texture%2C%20film%20grain%2C%20editorial%20investigation%20board%20style%2C%20no%20readable%20text%2C%20no%20identifiable%20people&width=1200&height=820&seq=chigua-sh4&orientation=landscape",
  },
];

export interface RecordItem {
  title: string;
  source: string;
  time: string;
  cover: string;
}

export const recordFeeds: RecordItem[] = [
  {
    title: "后台录屏流出 · 操作台全流程 4 分钟",
    source: "来源 · 内部片段",
    time: "05:20",
    cover: "https://readdy.ai/api/search-image?query=desktop%20screen%20recording%20interface%20with%20timeline%20bars%20and%20a%20small%20webcam%20window%2C%20warm%20monitor%20glow%2C%20coral%20accents%2C%20film%20grain%2C%20editorial%20behind%20the%20scenes%20collage%2C%20no%20identifiable%20faces&width=900&height=600&seq=chigua-rec1&orientation=landscape",
  },
  {
    title: "录音波形流出 · 关键 40 秒片段",
    source: "来源 · 音频录制",
    time: "00:40",
    cover: "https://readdy.ai/api/search-image?query=dark%20audio%20recording%20app%20with%20green%20and%20amber%20waveform%20and%20a%20glowing%20red%20rec%20button%2C%20warm%20ambient%20glow%2C%20film%20grain%2C%20editorial%20minimal%20collage%2C%20no%20readable%20text&width=900&height=600&seq=chigua-rec2&orientation=landscape",
  },
  {
    title: "笔记本回放流出 · 争议环节逐帧看",
    source: "来源 · 设备回放",
    time: "02:16",
    cover: "https://readdy.ai/api/search-image?query=laptop%20playing%20a%20paused%20clip%20with%20a%20progress%20bar%20and%20frame%20thumbnails%2C%20warm%20amber%20screen%20light%20on%20a%20desk%2C%20film%20grain%2C%20editorial%20collage%2C%20no%20identifiable%20people&width=900&height=600&seq=chigua-rec3&orientation=landscape",
  },
  {
    title: "横屏拍摄流出 · 现场实拍角度",
    source: "来源 · 现场拍摄",
    time: "03:08",
    cover: "https://readdy.ai/api/search-image?query=phone%20recording%20video%20in%20landscape%20held%20up%20toward%20a%20bright%20warm%20stage%20screen%2C%20lens%20flare%2C%20coral%20and%20amber%20tones%2C%20film%20grain%2C%20editorial%20cinema%20look%2C%20no%20identifiable%20faces&width=900&height=600&seq=chigua-rec4&orientation=landscape",
  },
];

export interface LiveItem {
  title: string;
  date: string;
  status: "回放中" | "完整版";
  cover: string;
}

export const liveReplays: LiveItem[] = [
  {
    title: "红毯夜场全程回放 · 高光混剪版",
    date: "回放 · 2 小时前",
    status: "回放中",
    cover: "https://readdy.ai/api/search-image?query=live%20broadcast%20studio%20set%20with%20ring%20lights%20and%20a%20phone%20gimbal%2C%20warm%20amber%20stage%20lighting%2C%20coral%20backdrop%2C%20cinematic%20bokeh%2C%20film%20grain%2C%20editorial%20premium%20look%2C%20no%20identifiable%20people&width=1400&height=900&seq=chigua-live1&orientation=landscape",
  },
  {
    title: "深夜连麦局全程 · 情绪峰值全记录",
    date: "回放 · 昨晚",
    status: "完整版",
    cover: "https://readdy.ai/api/search-image?query=camera%20operator%20filming%20a%20small%20talk%20stage%20under%20warm%20stage%20light%2C%20orange%20and%20amber%20glow%2C%20blurred%20crowd%2C%20film%20grain%2C%20editorial%20cinema%20poster%2C%20no%20identifiable%20faces&width=1400&height=900&seq=chigua-live2&orientation=landscape",
  },
];

export interface MemeItem {
  title: string;
  tag: string;
  cover: string;
}

export const memeGrid: MemeItem[] = [
  {
    title: "阴阳怪气 · 斜眼表情",
    tag: "S级",
    cover: "https://readdy.ai/api/search-image?query=cartoonish%20reaction%20sticker%20of%20a%20skeptical%20side%20eye%20expression%20in%20bold%20line%20art%2C%20warm%20amber%20and%20coral%20flat%20colors%2C%20clean%20paper%20background%2C%20sticker%20pack%20style%2C%20playful%2C%20no%20identifiable%20person&width=800&height=800&seq=chigua-meme1&orientation=squarish",
  },
  {
    title: "吃瓜群众 · 瓜子围观",
    tag: "常青",
    cover: "https://readdy.ai/api/search-image?query=pile%20of%20popcorn%20kernels%20and%20aviator%20sunglasses%20meme%20props%20on%20a%20warm%20beige%20background%2C%20flat%20editorial%20illustration%2C%20coral%20and%20amber%20tones%2C%20clean%20and%20fun%2C%20no%20faces&width=800&height=800&seq=chigua-meme2&orientation=squarish",
  },
  {
    title: "暗中观察 · 左右偷瞄",
    tag: "热梗",
    cover: "https://readdy.ai/api/search-image?query=animated%20eyes%20darting%20side%20to%20side%20on%20a%20cream%20comic%20background%2C%20bold%20warm%20colors%2C%20coral%20and%20amber%20palette%2C%20flat%20vector%20sticker%20style%2C%20playful%2C%20no%20identifiable%20person&width=800&height=800&seq=chigua-meme3&orientation=squarish",
  },
  {
    title: "狗带围观 · 戴墨镜冷静",
    tag: "常青",
    cover: "https://readdy.ai/api/search-image?query=golden%20retriever%20meme%20dog%20wearing%20sunglasses%20on%20a%20pastel%20warm%20background%2C%20flat%20illustration%2C%20coral%20and%20amber%20tones%2C%20clean%20sticker%20style%2C%20fun%2C%20cute%2C%20no%20real%20identifiable%20person&width=800&height=800&seq=chigua-meme4&orientation=squarish",
  },
  {
    title: "气到变形 · 红蜡笔暴躁",
    tag: "爆款",
    cover: "https://readdy.ai/api/search-image?query=hand%20drawn%20comic%20angry%20scribble%20face%20shouting%20in%20bold%20red%20crayon%20lines%2C%20warm%20cream%20background%2C%20flat%20editorial%20illustration%2C%20energetic%2C%20no%20identifiable%20person&width=800&height=800&seq=chigua-meme5&orientation=squarish",
  },
  {
    title: "破防了 · 流泪猫猫头",
    tag: "新晋",
    cover: "https://readdy.ai/api/search-image?query=expressive%20cartoon%20cat%20with%20tears%20and%20dramatic%20paw%20gesture%2C%20warm%20orange%20flat%20colors%2C%20clean%20paper%20background%2C%20sticker%20pack%20style%2C%20emotional%20and%20playful%2C%20no%20identifiable%20person&width=800&height=800&seq=chigua-meme6&orientation=squarish",
  },
];

export const trendTimeline = [
  { time: "起 · 第 1 天", label: "源头片段流出，粉丝群开始搬运", hot: "1.2万" },
  { time: "涨 · 第 2 天", label: "截图合集补全，二次创作爆发", hot: "5.8万" },
  { time: "热 · 第 3 天", label: "录屏流出与弹幕梗同步发酵", hot: "9.7万" },
  { time: "顶 · 第 4 天", label: "直播回放上线，媒体转载", hot: "14万" },
  { time: "散 · 第 5 天", label: "表情包二次传播，长尾讨论", hot: "8.1万" },
];

export const trendTopics = [
  { label: "时间线复盘", hot: 96 },
  { label: "名场面切片", hot: 88 },
  { label: "弹幕名梗", hot: 79 },
  { label: "争议环节", hot: 71 },
  { label: "同款表情包", hot: 63 },
];

export const faqList = [
  {
    q: "视频片段和截图合集会不会重复？",
    a: "不会。片段按『完整素材』归档，截图合集按『关键节点』整理，两者互为补充。你在片段里看到的高能瞬间，基本都能在对应截图合集里找到同帧证据，方便快速出图或引用。",
  },
  {
    q: "录屏流出和直播回放有什么区别？",
    a: "录屏流出多为设备直接录制、未经过剪辑的原始视角；直播回放则是平台保存下来的完整节目，画质更稳定。两者来源不同、可信度标准也不同，页面里都标注了来源提示。",
  },
  {
    q: "素材可以随便拿去二创或引用吗？",
    a: "本站只做归档与整理，供你快速取素材、跟传播节奏。转发、剪辑或商用前请自行核对出处与版权，尊重原作者权益。素材统一标注来源，方便你追本溯源。",
  },
  {
    q: "为什么同一件事会有不同时间的版本？",
    a: "事件是滚动的。我们按『传播节奏』把起、涨、热、顶、散五个阶段分开归档，每个时间点对应的片段、截图、录屏和回放都归到各自阶段，避免时间线混乱。",
  },
];

export const trustStats = [
  { num: "3200+", label: "归档素材条数" },
  { num: "98", label: "主题时间线" },
  { num: "24h", label: "更新响应" },
  { num: "100%", label: "逐条标来源" },
];